import bookingRoutes from './booking'
import orderRoutes from './order'

export default [
  ...bookingRoutes,
  ...orderRoutes
]